import axios from 'axios';
import qs from 'qs';
import React, { Component } from 'react';
import moment from 'moment';

import {
  headerService$
} from "../../utils/rxjs-sharing";
import {
  Modal,
  notification,
  Button,
  Tooltip
} from 'antd';
import {
  REFERENCE_TYPE,
  LOADER,
  HOSPITALDEFAULTS,
  ISALLOWEDITSOAP,
  PATIENT_DATA,
  APPLY_ORDERSET,
  DRUG,
  SEARCH_DRUGS,
  PRESCRIPTION_DATA,
  PRESCRIPTION_STORE,
  DRUGS_CONSTANT,
  DELETE_MEDICINE,
  DRUG_FAVOURITE,
  BMI_CALCULATE,
  BSA_CALCULATE,
  ASSESSMENT_API,
  LAST_VITAL_ADDED_DATA,
  SAVE_TARGET_BLOOD_SUGAR,
  PATIENT_INFO,
  MEDICINES_GETALL_CURRENT_MEDICINES,
  MEDICINES_GETALL,
  CURRENT_MEDICINES_STOP,
  DELETE_All_MEDICINE,
  CIMSALLOW,
  CIMS_ALLOW_HOSPITALS,
  CIMS_INTERACTION_EXISTS,
  CIMS_INTERACTION,
} from "../../utils/constant";

import LS_SERVICE from '../../utils/localStorage';
import SoapFlow from '../../utils/soap';
import MedicineForm from "../../components/drugs/medicine-form";
import OrdersetList from "../../components/orderset/orderset-list";
import MedicineTable from "../../components/drugs/medicine-table";
class PlanMedicineComponentSS extends Component {

  constructor(props) {
    super(props);
    this.state = {
      allowEdit: true,
      isPracticing: false,
      isPracticingModal: false,
      deleteConfirmModal: false,
      polyPharmacyModal: false,
      polyPharmacyFavModal: false,
      selectedDrug: null,
      showtapper: true,

      selectedOrderSet: [],
      selectedConfirmedOrderSetData: [],
      planFavDrugsModal: false,
      drugsData: [],
      addedDrugsList: [],
      diabaticPatient: false,
      target_blood_sugar_max: null,
      target_blood_sugar_min: null,
      medicine_success: '',
      current_medicines: [],
      presMedicine: [],
      showDupMed: [],
      currentMedsLists: [],
      duplicateMedModel: false,
      polyPharmacyWarningShown: false,
      eventFav: {},
      favMedData: {},
      constants: {},
      favourite: {},
      favourite_list_all: {},
      dataLoaded: false,
      shownPolymodelFav: false,
      diableConfrimButton: true,
      isModalInteractionVisible: false,
      selectedDrug: null,
      cimsallow: CIMSALLOW,
      drug_id_Interaction_Modalurl:[],
      referenceType:0,
      patientId: LS_SERVICE.get("call_patient_id") != undefined ? LS_SERVICE.get("call_patient_id") : 0,
      referenceId: LS_SERVICE.get("call_patient_qms_token_id") != undefined ? LS_SERVICE.get("call_patient_qms_token_id") : 0,
      StoreId: LS_SERVICE.get("staff_id") != undefined ? LS_SERVICE.get("staff_id") : 0,
      FacilityId: LS_SERVICE.get("FACILITY_ID") != undefined ? LS_SERVICE.get("FACILITY_ID") : 0,
      enterpriseId: LS_SERVICE.get("ENTERPRISE_ID") != undefined ? LS_SERVICE.get("ENTERPRISE_ID") : 0,
      hospitalId: parseInt(LS_SERVICE.get('slot_hospital_id'))
    };
    this.medFormRef = React.createRef();
    this.handleDeleteAll = this.handleDeleteAll.bind(this);
    this.checkCimsInteraction    = false;
    this.checkCimsInteractionfav = false;
    this.addFavMed               = false;
  }

  async componentDidMount() {
    axios.defaults.headers.common["Authorization"] = LS_SERVICE.get("token");
    this.setState({
      isDataFetching: true,
    });
    const { patient } = this.props;
    const hospital_id = patient.qmsToken.hospital_id;
    const patient_id = patient.patient_id;
    const reference_id = patient.qms_token_id;
    const isPracticingHospitalId = LS_SERVICE.get("practicing")?.hospital_id;
    await this.loadData();
    if (+isPracticingHospitalId === +hospital_id) {
      this.setState({
        isPracticing: true,
      });
    }
    if (this.state.patient) {
      await this.setState({
        patientData: this.state.patient,
      });
    } else {
      await this.getPatientData(reference_id);
    }

    let hospitalConfigData = LS_SERVICE.get("hospitalConfigData") ?? [];
    hospitalConfigData = hospitalConfigData.find((item) => item.hospital_id == hospital_id);

    let allowEdit = hospitalConfigData
      ?
      ISALLOWEDITSOAP(
        hospitalConfigData.pres_modification,
        hospitalConfigData.allow_hours,
        LS_SERVICE.get("appointmentCompletedTime")[reference_id],
        "button"
      )
      :
      true
      ;
    this.setState({ hospital_id, patient_id, reference_id, patient, allowEdit }, async () => {
      if (LS_SERVICE.has("hospitalConfigData")) {
        const hospitalConfigData = LS_SERVICE.get("hospitalConfigData");
        let hospitalConfigObj = hospitalConfigData.find((obj) => obj.hospital_id == hospital_id);
        headerService$.soapConfig({ soapConfig: hospitalConfigObj.opd_layout });
        this.setSoapFlow();
        this.handleInitialData();
      }
    });
    await this.setState({
      dataLoaded: true
    })
  }

  async setSoapFlow() {
    const { hospital_id } = this.state;
    SoapFlow.hospital(hospital_id)
  }

  polyPharmacyWarningShown = () => {
    this.setState({
      polyPharmacyWarningShown: true,
    })
  }

  clearEdit = () => {
    this.setState({
      editData: null,
      selectedDrug: null,
      editIndex: -1,
    });
  };

  showPolyModal = () => {
    this.setState({ polyPharmacyModal: true });
  };


  handlePolyOk = () => {
    this.setState({ polyPharmacyModal: false, polyPharmacyWarningShown: true }, async () => {
      var selected_order_set = []
      for (var data of this.state.selectedOrderSet) {
        await axios.get(APPLY_ORDERSET({
          orderset_id: data.orderSetId,
          patient_id: this.state.patient?.patient_id,
          reference_type: REFERENCE_TYPE,
          reference_id: this.state.patient?.qmsToken?.qms_token_id
        }))
        selected_order_set.push(data)
      }
      await this.setState({
        showOrdersetModal: false,
        selectedConfirmedOrderSetData: this.state.selectedOrderSet,
        selectedOrderSet: this.state.selectedOrderSet
      })

      this.props.updateInstructionFromParent();

      this.loadData().then(success2 => {
        this.handleInitialData()
      })
    });
  };

  handlePolyCancel = (e) => {
    this.setState({ polyPharmacyModal: false, polyPharmacyWarningShown: true });
  };

  handlePolyFavCancel = (e) => {
    this.setState({ polyPharmacyFavModal: false });
  };

  showPolyModalForfav = (e) => {
    this.setState({ polyPharmacyFavModal: true });
  };

  handlePolyFavOk = async (e) => {
    const { eventFav, favMedData } = this.state
    await this.setState({ polyPharmacyFavModal: false, shownPolymodelFav: true });
    eventFav.target.checked = true;
    this.selectFavDrug(eventFav, favMedData);
  }

  IsApplyFav = async (data) => {

    let arr_conacat         = "";
    arr_conacat             = data.id;
    let {referenceId,StoreId,FacilityId,enterpriseId,patientId} = this.state
    let referenceType       = 0;
    let careProtoColId      = 0;
    let drugIds             = arr_conacat;
    let orederSetId         = 0;
    let medicineScreen      = 'addFavMed';
    let addedAssessmentList = 0;

    if (CIMSALLOW && CIMS_ALLOW_HOSPITALS.includes(this.state.hospitalId)) {
    await axios.get(CIMS_INTERACTION_EXISTS({ drugIds, referenceType, referenceId, orederSetId, patientId, enterpriseId, FacilityId, StoreId, careProtoColId, medicineScreen, addedAssessmentList }))
      .then(success => {
        if (success?.data?.interaction) {
          this.checkCimsInteractionfav = true;
          this.setState({ drug_id_Interaction_Modalurl:drugIds,careProtoColId: careProtoColId, referenceType: referenceType, referenceId: referenceId, orederSetId: orederSetId, enterpriseId: enterpriseId, FacilityId: FacilityId, StoreId: StoreId, patientId: patientId,drugData:data, isModalInteractionVisibleFav: this.checkCimsInteractionfav });
        }
        else {
          this.checkCimsInteractionfav = false;
          this.addFavMed               = true;
          const {drugData}             = this.state;
          let e ={
            checkConditon:true,
            target:{checked:true}
          }
          this.selectFavDrug(e,data,'','cims');
        }
      })
      .catch(err => console.log(err))
          
    }else{
      this.checkCimsInteractionfav = false;
      this.addFavMed               = true;
      const {drugData}             = this.state;
      let e ={
        checkConditon:true,
        target:{checked:true}
      }
      this.selectFavDrug(e,data,'','cims');
    }
  }

  selectFavDrug = async (e, data, checkIndex =null,type= null) => {
    if(type==null){
      e.preventDefault();
    }
    let addFavMed;
    if (e.target.checked == true) {
      addFavMed = true;
    } else {
      addFavMed = false;
    }
    
    if (e?.target.checked == true) {
      if(type==null){
        this.IsApplyFav(data)
        return;
      }
    } else {
      this.addFavMed = false;
    }

    if (this.state.current_medicines?.length > HOSPITALDEFAULTS.maximum_medicines_allowed && !this.state.shownPolymodelFav) {
      this.showPolyModalForfav()
      this.setState({ favMedData: data, eventFav: e })
      return;
    }
    this.setState({
      shownPolymodelFav: false
    })
    if (e?.checkConditon != false) {
      const { patient_id, qms_token_id } = this.state.patient;
      await axios.get(MEDICINES_GETALL_CURRENT_MEDICINES({ patient_id, reference_type: 0, reference_id: qms_token_id })).
        then(success => {
          let currentMedsList = success.data.data.details.current_medicines;
          this.setState({
            currentMedsLists: currentMedsList,
          })
        }).catch(error => {
          console.error(error, "error");
        });

      const { currentMedsLists } = this.state
      let dupMedicine = [];
      currentMedsLists.map((med, i) => {
        if (data.id == med.drug_id && med.prescriptionDrugActive == 'Y')
          dupMedicine.push(med)
      })
      if (dupMedicine.length > 0) {
        const ids = dupMedicine.map(o => o.drug_id)
        const filteredMed = dupMedicine.filter(({ drug_id }, index) => !ids.includes(drug_id, index + 1))
        this.setState({
          presMedicine: dupMedicine, showDupMed: filteredMed, duplicateMedModel: true, eventFav: e,
          favMedData: data,
          shownPolymodelFav: false
        })
        return;
      }
    }
    if (addFavMed == true) {
      data.title = data.name;
      await this.setState({
        selectedDrug: data,
      })
      var drug_data_response = await axios.post(DRUG, qs.stringify({
        id: data.id
      }));
      var drug_data = drug_data_response?.data?.data?.result;
      var quantity_text = null;
      var quantity = null;
      if (drug_data?.frequency == 3) {
        quantity = drug_data?.dosage;
      } else {
        if (drug_data?.drug_frequency?.[0]?.frequency_id?.id === 15) {
          let numberOfDays = Math.ceil(drug_data?.drug_duration / 2);
          quantity = Math.ceil(parseInt(numberOfDays) * drug_data?.dosage * drug_data?.drug_frequency?.[0]?.frequency_id.total_repeats);
        } else {
          quantity = parseInt(drug_data?.drug_duration) * drug_data?.dosage * drug_data?.drug_frequency?.[0]?.frequency_id.total_repeats;
        }
      }
      if (drug_data?.form_id?.fixed_quantity && drug_data?.form_id?.fixed_quantity != null) {
        quantity = drug_data?.form_id?.fixed_quantity;
        quantity_text = 'Unit';
      }
      var end_date = await this.updateEndDate(drug_data?.drug_duration, drug_data?.drug_duration_time, drug_data?.drug_frequency?.[0]?.frequency_id?.id, moment().format('YYYY-MM-DD'))
      var schedules_name = '';
      if (drug_data?.drug_frequency?.length > 0 && typeof drug_data?.drug_frequency?.[0]?.frequency_id != 'undefined') {
        var frequencyid = drug_data?.drug_frequency?.[0]?.frequency_id.id;
        let frequencyObjKey = Object.keys(this.state.constants.dailyFrequency).find(key => this.state.constants.dailyFrequency[key].id === frequencyid)
        schedules_name = this.state.constants.dailyFrequency[parseInt(frequencyObjKey)].schedule.map(function (obj) { return obj.description }).toString().replace(/,/g, '-');
      }
      await this.updateMedicineData({
        id: null,
        i: -1,
        drug_generic: drug_data?.drug_generic,
        active: "Y",
        drug_id: drug_data?.id,
        drug_form: drug_data?.form_id?.id,
        strength: drug_data?.drug_dosage?.[0]?.strength,
        dosage: drug_data?.dosage,
        dosage_value: this.state.constants?.drugDosage.find(item => item?.id == drug_data?.dosage)?.description,
        route: drug_data?.drug_route?.[0]?.route_id,
        drug_frequency: drug_data?.frequency,
        daily_frequency: drug_data?.drug_frequency?.[0]?.frequency_id?.id,
        number_of_days: drug_data?.drug_duration,
        number_of_days_type: drug_data?.drug_duration_time,
        days_in_week_text: null,
        days_in_week: drug_data?.days_in_week?.split(',').map(element => Number(element)),
        quantity: quantity,
        instruction: drug_data?.instruction,
        medicine_remarks: drug_data?.medicine_remarks,
        drug_name: drug_data?.name,
        dosage_form: 0,
        dosage_form_text: drug_data?.drug_dosage?.[0]?.uom_second?.short_description,
        drug_fixed_qty: drug_data?.form_id?.fixed_quantity,
        prescription_drug_id: -1,
        urgency: drug_data?.urgency,
        schedules: drug_data?.schedules?.split(',').map(element => Number(element)),
        schedule_name: schedules_name,
        addContinueTillReview: end_date && end_date != null ? "N" : 'Y',
        start_date: moment().format('YYYY-MM-DD'),
        end_date: end_date,
        fav_selected: true
      });
      // this.loadData().then(success2 => {
      //   this.handleInitialData()
      // })
      this.setState({
        shownPolymodelFav: false
      })
    }
  }

  stopCurentMeds() {
    const { presMedicine, eventFav, favMedData } = this.state;
    let stopDrugIds = presMedicine.map((drugDetailsId) => { return drugDetailsId.prescriptionDrugId })
    let doctor_id = LS_SERVICE.get('staff_id');
    let params = {
      stopDrugIds: stopDrugIds,
    }
    let stopPrescriptionDrugId = null;
    axios.put(CURRENT_MEDICINES_STOP({ stopPrescriptionDrugId, doctor_id }), params).then(res => {
      this.setState({ duplicateMedModel: false, shownPolymodelFav: true })
      eventFav.target.checked = true;
      eventFav.checkConditon = false;
      this.selectFavDrug(eventFav, favMedData);
      notification.success({
        message: 'Drug stopped successfully',
        placement: 'topRight'
      });
    }).catch(
      err => {
        notification.error({
          message: 'failed to stop medicine',
          placement: 'topRight'
        });
        console.log(err);
      }
    );
  }
  updateEndDate = (drug_number_of_days, day_interval, drug_daily_frequency, drug_start_date) => {
    drug_number_of_days = drug_number_of_days;
    drug_daily_frequency = drug_daily_frequency;
    var end_date = null;
    if (drug_number_of_days && drug_daily_frequency && drug_start_date) {
      var number_of_days = parseInt(drug_number_of_days);
      var start_date = drug_start_date;
      let frequencyObjKey = Object.keys(this.state.constants.dailyFrequency).find(key => this.state.constants.dailyFrequency[key].id === drug_daily_frequency)
      frequencyObjKey = this.state.constants.dailyFrequency[parseInt(frequencyObjKey)]
      // var day_interval = frequencyObjKey.interval;
      var day_interval = day_interval && day_interval != null ? day_interval.toLowerCase() : '';
      day_interval = day_interval == "weeks" ? 7 : (day_interval == 'months' ? 30 : (day_interval == 'years' ? 365 : 1));
      var times_correction = frequencyObjKey.total_times;
      var dosage_per_day = frequencyObjKey.total_repeats;
      if (typeof number_of_days != 'undefined' && !isNaN(number_of_days) && typeof start_date != 'undefined' && start_date != '' && times_correction != 0) {
        if (day_interval != 1)
          // number_of_days = Math.round(number_of_days / dosage_per_day);
          // number_of_days = number_of_days * day_interval * times_correction;
          number_of_days = number_of_days * day_interval;
        end_date = moment(start_date, 'YYYY-MM-DD').add(number_of_days - 1, 'days').format('YYYY-MM-DD');
        end_date = moment(start_date, 'YYYY-MM-DD').add(number_of_days - 1, 'days').format('YYYY-MM-DD');
      }
      if (times_correction == 0) {
        end_date = moment(start_date, 'YYYY-MM-DD').add(number_of_days - 1, 'days').format('YYYY-MM-DD');
      }
    }
    else if (drug_start_date == null) {
      end_date = null;
    }
    return end_date;
  }

  onChangeTargetBloodSugar = (value) => {
    this.setState({
      [value.target.name]: parseInt(value.target.value)
    }, () => {
      if (this.state.target_blood_sugar_min && this.state.target_blood_sugar_max) {
        if (this.state.target_blood_sugar_min < this.state.target_blood_sugar_max) {
          this.setState({
            target_blood_sugar_error_message: ""
          })
          var PARAMS = {
            patient_id: this.state.patient.patient_id,
            target_blood_sugar_min: this.state.target_blood_sugar_min,
            target_blood_sugar_max: this.state.target_blood_sugar_max
          }
          axios.post(SAVE_TARGET_BLOOD_SUGAR, PARAMS);
        }
        else {
          this.setState({
            target_blood_sugar_error_message: "From value must be lesser than To value"
          })
        }
      }
      else {
        this.setState({
          target_blood_sugar_error_message: ""
        })
      }
    })
  }

  IsApplyOrdersets = async (e) => {
    let arr = [];
    let arr_conacat = "";
    let selectedData = this.state.selectedOrderSet;
    selectedData.map(obj => {
      arr.push(obj.orderSetId);
    })
    arr_conacat = arr.join('-')
   
    let referenceId         = this.state.referenceId
    let StoreId             = this.state.StoreId
    let FacilityId          = this.state.FacilityId
    let enterpriseId        = this.state.enterpriseId
    let patientId           = this.state.patientId
    let referenceType       = 0;
    let orederSetId         = arr_conacat || 0;
    let drugIds             = 0;
    let careProtoColId      = 0;
    let medicineScreen      = 'medicineform';
    let addedAssessmentList = 0;
    let showInteractionModal = false;
    if(CIMSALLOW && CIMS_ALLOW_HOSPITALS.includes(this.state.hospitalId)){
      axios.get(CIMS_INTERACTION_EXISTS({ drugIds,referenceType,referenceId,orederSetId,patientId,enterpriseId,FacilityId,StoreId,careProtoColId,medicineScreen,addedAssessmentList }))
            .then(success => {
              if (success.data.interaction) {
                showInteractionModal = true;
                this.setState({ drug_id_Interaction_Modalurl: drugIds,referenceType:referenceType,referenceId:referenceId,orederSetId:orederSetId,enterpriseId:enterpriseId,FacilityId:FacilityId,StoreId:StoreId,patientId:patientId,isModalInteractionVisible: showInteractionModal});
              }
              else{
                this.ApplyOrdersets(e);
              }
            })
            .catch(err => console.log(err))
    }else{
      this.ApplyOrdersets(e);
    }
  }

  ApplyOrdersets = async (e) => {
    if (e !== null) e.preventDefault();
    // if (this.state.current_medicines?.length > HOSPITALDEFAULTS.maximum_medicines_allowed && !this.state.polyPharmacyWarningShown) {
    //   await axios.get(MEDICINES_GETALL({ patient_id: this.state.patient?.patient_id }))
    //     .then(response => {
    //       let currentMedsList = response?.data?.data?.details?.current_medicines;
    //       let tempArr = currentMedsList.map(function (v) { return v.drug_id });
    //       tempArr = tempArr.filter(function (item, pos) { return tempArr.indexOf(item) == pos; })
    //       this.setState({
    //         current_medicines: tempArr
    //       })
    //     })
    //   this.showPolyModal()
    // }
    //  else {
    var selected_order_set = []
    for (var data of this.state.selectedOrderSet) {
      await axios.get(APPLY_ORDERSET({
        orderset_id: data.orderSetId,
        patient_id: this.state.patient?.patient_id,
        reference_type: REFERENCE_TYPE,
        reference_id: this.state.patient?.qmsToken?.qms_token_id
      }))
      selected_order_set.push(data)
    }
    await this.setState({
      showOrdersetModal: false,
      selectedConfirmedOrderSetData: this.state.selectedOrderSet,
      selectedOrderSet: this.state.selectedOrderSet
    })

    this.props.updateInstructionFromParent();

    this.loadData().then(success2 => {
      this.handleInitialData()
    })
    // }
  };

  markDrugFavorite = (data) => {
    axios.post(DRUG_FAVOURITE, qs.stringify({
      drug_id: data.id,
      fav_drug: [{
        drug_id: data.id,
        drug_name: data.name,
        drug_form: '',
        dosage_form: '',
        strength: '',
        dosage: '',
        route: '',
        drug_frequency: '',
        urgency: '',
        daily_frequency: '',
        fav: 0,
        number_of_days: '',
        number_of_days_type: ''
      }],
      hospital_id: LS_SERVICE.get('slot_hospital_master') == 'Y' ? LS_SERVICE.get('slot_hospital_id') : null
    })).then(success => {
      this.loadData().then(success2 => {
        this.handleInitialData()
      })
    }).catch(err => {
      console.log(err)
    })
  }

  getPatientData = (_) => {
    const { patient } = this.props;
    const patient_id = patient.patient_id;
    axios.get(PATIENT_DATA({ patient_id }))
      .then((success) => {
        const patient = {
          ...success.data.data.results,
          qms_token_id: success.data.data.results.qmsToken ? success.data.data.results.qmsToken.qms_token_id : null,
        };

        // this.setState({ patient });
      })
      .catch((err) => console.log(err));
  };

  handlePracticeModal = data => {
    this.handleModalPopup(null, data);
  }

  /* async componentWillReceiveProps(){
    await this.handleInitialData();
  } */

  async handleDeleteAll(props) {
    var PARAMS = {
      all_prescription_id: props,
    }
    await axios.post(DELETE_All_MEDICINE, PARAMS)
      .then((success) => {
        this.handleInitialData();
        this.props.viewlengthMedicineData({count:0, details: []});
        this.setState({
          spin_loading: false
        });
      })
      .catch((err) => console.log(err));
  }

  handleModalPopup = (e, popupName, data = null, actionType = "", objId = "", showtapper = true) => {
    if (e !== null) e.preventDefault();
    this.setState(
      {
        [popupName]: !this.state[popupName],
        showtapper:showtapper
      },
      () => {
        const { viewDocumentModal } = this.state;
        if (popupName == 'showMedicineModal' && this.state[popupName] == false) {
          this.setState({
            selectedDrug: null,
          })
        }
        this.setState(
          {
            actionText: "Add",
            editData: null,
            editIndex: -1,
          },
          () => {
            const { deleteConfirmModal, showMedicineModal } = this.state;

            if (showMedicineModal) {
              let finaldata = [...this.state.drugsData]?.sort((a, b) => a.drug_id - b.drug_id); 
              if (actionType === "editMedicine") {
                this.setState({
                  actionText: "Edit",
                  editData: finaldata[objId],
                  editIndex: objId,
                });
                this.handleAddedMeds()
              }
            }

            if (deleteConfirmModal) {
              // For Medicines
              if (actionType === "deleteMedicine") {
                this.setState({ deleteActionType: actionType, deleteObjId: objId, deleteMessage: "Are you sure you want to delete medicine?" });
              }
            }
          }
        );
      }
    );
    this.loadData().then(success2 => {
      this.handleInitialData()
    })
  };

  handleOrderSetPopup = async (e, type) => {
    if (e !== null) e.preventDefault();
    await this.setState({
      showOrdersetModal: type == 'show' ? true : false,
    })
    if (type == 'hide') {
      await this.setState({
        selectedOrderSet: this.state.selectedConfirmedOrderSetData,
        selectedConfirmedOrderSetData: this.state.selectedConfirmedOrderSetData
      })
    }
    this.loadData().then(success2 => {
      this.handleInitialData()
    })
  }

  handleCurrentMedicines = async () => {
    this.medFormRef.current.handleActiveMedsList()
  }

  handleOnItemDelete = async (e, actionType, objId) => {
    e.preventDefault();
    var stateVariable = null;
    var stateAddedVariable = null;
    var propKey = null;
    var deleteUrl = null;

    // For Drug
    if (actionType === "deleteMedicine") {
      stateVariable = "drugsData";
      stateAddedVariable = "addedDrugsList";
      propKey = "drug_id";
      deleteUrl = DELETE_MEDICINE;
    }

    let dataArray = this.state[stateVariable];
    var deleteObj = dataArray[objId];
    var deleteId = deleteObj.id;
    if (actionType === "deleteMedicine")
    { 
      let finaldata = [...dataArray]?.sort((a, b) => a.drug_id - b.drug_id); 

       deleteObj = finaldata[objId];
       deleteId = deleteObj.id;
       deleteId = deleteObj.prescription_drug_id;
    }

    this.setState({
      spin_loading: true,
    });
    dataArray.splice(objId, 1);
    let addedArray = [];
    dataArray.map((v, k) => {
      addedArray.push(v[propKey]);
    });
    this.setState({
      deleteConfirmModal: false,
      [stateVariable]: dataArray,
      [stateAddedVariable]: addedArray,
    });
    axios.get(deleteUrl({ id: deleteId }))
      .then((success) => {
        this.handleInitialData();
        this.setState({
          spin_loading: false
        });
        this.handleAddedMeds();
      })
      .catch((err) => console.log(err));
  };

  updateMedicineData = async (data, showTaper) => {
    data.selected = true;
    let drugsData = this.state.drugsData;
    let addedDrugsList = [];
    var index = data.i;
    if (index == -1) index = drugsData == null ? 0 : drugsData.length;
    drugsData[index] = data;

    addedDrugsList = drugsData.map((v, k) => {
      return v.drug_id;
    });
    const PARAMS = {
      reference_type: REFERENCE_TYPE,
      reference_id: this.state.patient.qms_token_id,
      patient_id: this.state.patient.patient_id,
      medicine_data: [data],
    };
    if (data?.prescription_drug_id > 0) {
      if (!showTaper) this.handleModalPopup(null, "showMedicineModal");
    }
    const medsFormPromise = await axios.post(PRESCRIPTION_STORE, qs.stringify(PARAMS));
    this.setState({ editData: null, editIndex: -1, drugsData, addedDrugsList });
    if (medsFormPromise.data) {
      await this.loadData();
      await this.handleInitialData();
      await this.handleAddedMeds();
      if (data?.prescription_drug_id > 0) {
        // if (!showTaper) this.handleModalPopup(null, "showMedicineModal");
        notification.success({
          message: medsFormPromise.data.message,
          placement: "topRight",
        });
      }
      else {
        if (!data?.fav_selected) {
          this.setState({
            medicine_success: data.drug_name + ' added successfully'
          })
          setTimeout(async () => {
            this.setState({
              medicine_success: ''
            })
          }, 7000);
        }
      }
    }
  };

  selectOrderSet = async (data, checked) => {
    if (data.diableConfrimButton.length > 0) {
      this.setState({
        diableConfrimButton: false
      })

    } else {
      this.setState({
        diableConfrimButton: true
      })
    }

    var selectedOrderSet = this.state.selectedOrderSet
    if (checked == true) {
      data.is_selected = 'Y';
      selectedOrderSet.push(data)

    } else {
      selectedOrderSet = selectedOrderSet.filter((item) => item.orderSetId !== data.orderSetId);
    }
    await this.setState({
      selectedOrderSet: selectedOrderSet
    })
  };

  loadData = async () => {
    let { constants, favourite } = this.state;

    // Drug Constants
    const drugConstants = await axios.get(DRUGS_CONSTANT);
    constants = drugConstants.data.data;

    // Fav Drugs
    let drug_params = {
      hospital_id: LS_SERVICE.get('slot_hospital_master') == 'Y' ? LS_SERVICE.get('slot_hospital_id') : null,
      distinct: 'Y'
    };
    const drugsFavourite = await axios.post(SEARCH_DRUGS, qs.stringify(drug_params));
    if (drugsFavourite.data.hasOwnProperty("medicine_list") === true) {
      favourite.medicines = drugsFavourite.data.medicine_list;
    }

    await this.setState({
      constants: constants,
      favourite: favourite,
    });
  };

  handleAddedMeds = async () => {
    const { patient_id, qms_token_id } = this.state.patient;
    const planDrugAdvPromise = await axios.get(PRESCRIPTION_DATA({
      hospital_id: LS_SERVICE.get('slot_hospital_master') == 'Y' && LS_SERVICE.get('slot_hospital_id') ? LS_SERVICE.get('slot_hospital_id') : null,
      patient_id,
      reference_type: LS_SERVICE.get('reference_type'),
      reference_id: qms_token_id,
      store_id: LS_SERVICE.get("STORE_ID"),
      facility_id: LS_SERVICE.get("FACILITY_ID"),
      enterprise_id: LS_SERVICE.get("ENTERPRISE_ID")
    }))
    if (planDrugAdvPromise.data.status === 'success') {
      const { duplicateOrderDrugs, details } = planDrugAdvPromise.data.data;
      let addedDrugsList = [];
      addedDrugsList = details.map((v, k) => { return v.drug_id });
      await this.setState({
        drugAdvisedDuplicateOrders: duplicateOrderDrugs,
        drugsData: details,
        addedDrugsList
      })
      if(details.length > 0){
        this.props.viewMedicineData();
        this.props.getDrugsList(addedDrugsList);
      }
    }
    // var drugs = this.state.drugsData;
    // var fav_d = this.state.favourite?.medicines;
    // var fav_drugs = await fav_d?.map(function (x) {
    //   var result = drugs.filter(medicine => medicine.drug_id == x.id);
    //   if (result.length > 0) { x.is_selected = 'Y' }
    //   else { x.is_selected = 'N' }
    //   return x
    // })
    // var fav = this.state.favourite;
    // fav.medicines = fav_drugs;
    // await this.setState({
    //   favourite: fav,
    //   favourite_list_all: fav
    // });
  };

  handleInitialData = async () => {
    const { patient_id, qms_token_id } = this.state.patient;
    const planDrugAdvPromise = await axios.get(PRESCRIPTION_DATA({
      hospital_id: LS_SERVICE.get('slot_hospital_master') == 'Y' && LS_SERVICE.get('slot_hospital_id') ? LS_SERVICE.get('slot_hospital_id') : null,
      patient_id,
      reference_type: REFERENCE_TYPE,
      reference_id: qms_token_id
    }))
    if (planDrugAdvPromise.data.status === 'success') {
      const { duplicateOrderDrugs, details } = planDrugAdvPromise.data.data;
      let addedDrugsList = [];
      addedDrugsList = details.map((v, k) => { return v.drug_id });
      await this.setState({
        drugAdvisedDuplicateOrders: duplicateOrderDrugs,
        drugsData: details,
        addedDrugsList
      })
      if (details.length > 0) {
        this.props.viewMedicineData();
        this.props.getDrugsList(addedDrugsList);
        this.props.viewlengthMedicineData({count:details.length, details: details});
      }
      else{
        this.props.viewlengthMedicineData({count:0, details: details});
      }
      this.checkMedicineDataEmpty()
    }
    var drugs = this.state.drugsData;
    await this.state.favourite?.medicines?.map(function (x) {
      var result = drugs.filter(medicine => medicine.drug_id == x.id);
      if (result.length > 0) { x.is_selected = 'Y' }
      else { x.is_selected = 'N' }
      return x
    })
    var fav = this.state.favourite;
    fav.medicines = this.state.favourite?.medicines;
    await this.setState({
      favourite: fav
    });

    await this.setState({
      favourite_list_all: this.state.favourite
    })

    await axios.get(LAST_VITAL_ADDED_DATA({ patient_id }))
      .then(success => {
        this.setState({
          heightbmi: success.data.data.results.height,
          weightbmi: success.data.data.results.weight
        }, () => {
          if (success.data.data.results.height != '' && success.data.data.results.weight != '') {
            let bmi = BMI_CALCULATE(success.data.data.results.height, success.data.data.results.weight);
            let bsa = BSA_CALCULATE(success.data.data.results.height, success.data.data.results.weight);
            this.setState({
              bmi: bmi,
              bsa: bsa
            });
          }
        })
      })

    await axios.get(ASSESSMENT_API({ reference_type: REFERENCE_TYPE, reference_id: qms_token_id }))
      .then(assessDataPromise => {
        if (assessDataPromise.data) {
          let { data } = assessDataPromise.data;
          if (data.activeDiagnosisDetails || data.activeDiagnosisDetails.length > 0) {
            data.activeDiagnosisDetails.map((data_active, i) => {
              if (data_active?.is_diabetic == 'Y') {
                this.setState({ diabaticPatient: true });
              }
            });
          }
        }
      });

    await axios.get(PATIENT_INFO({ patient_id: patient_id, reference_id: qms_token_id }))
      .then(response => {
        this.setState({
          target_blood_sugar_max: response?.data?.data?.results?.target_blood_sugar_max,
          target_blood_sugar_min: response?.data?.data?.results?.target_blood_sugar_min
        })
      })
    await axios.get(MEDICINES_GETALL({ patient_id: patient_id }))
      .then(response => {
        let currentMedsList = response?.data?.data?.details?.current_medicines;
        let tempArr = currentMedsList.map(function (v) { return v.drug_id });
        tempArr = tempArr.filter(function (item, pos) { return tempArr.indexOf(item) == pos; })
        this.setState({
          current_medicines: tempArr
        })
      })
  };

  handleCancel = () => {
    this.setState({ planFavDrugsModal: false });
    this.loadData().then(success2 => {
      this.handleInitialData()
    })
  }

  FavouriteListLoad = async (e) => {

    var searchTerm = e?.target?.value;

    let favourite_list_all = this.state.favourite;
    let filtered = favourite_list_all.medicines.filter(list => list.name.toString().toLowerCase().indexOf(searchTerm.toString().toLowerCase()) >= 0)

    await this.setState({
      favourite_list_all: { medicines: filtered }
    })
  };

  async handleMedPrecribedCancel() {
    await this.setState({
      duplicateMedModel: false,
    })
  }

  // printCompleteButton(checkMedData){
  //   this.props.printCompleteButtonDiabled(checkMedData);
  // }

  checkEmptyValue(val) {
    return typeof val == 'undefined' || val == null || val == '' ? true : false;
  }

  checkMedicineDataEmpty() {
    const { drugsData } = this.state;
    let checkMedData = false;
    drugsData.map((data) => {
      if (data.medicine_type == 'F') {
        if (this.checkEmptyValue(data.dosage_value)) { checkMedData = true };
        if (this.checkEmptyValue(data.route)) { checkMedData = true };
      }
    })
    this.props.printCompleteButtonDiabled(checkMedData)
    // medicineDataEmptyDisableButton.init({
    //   medicineDataEmpty: checkMedData
    // })
  }

  handleInteractionOk = (e) => { 
    this.setState({ isModalInteractionVisible: false,  })
    this.ApplyOrdersets(e);
   };
  handleInteractionCancel = () => { this.setState({ isModalInteractionVisible: false },
   ); };

   handleInteractionCancelFav = async () => {
    let { favourite,current_clicked} = this.state
    let {medicines} = favourite;
    current_clicked = 0;
   
    this.setState({isModalInteractionVisibleFav: false,isFav: false,current_clicked:current_clicked}, () => { this.addFavMed = false})
   
  };

  handleInteractionOkFav = async () => {
    await this.setState({ isModalInteractionVisibleFav: false,isFav: true }, () => { this.addFavMed = this.state.isFav})
    const {drugData} = this.state
    let e ={
      checkConditon:true,
      target:{checked:true}
    }
    this.selectFavDrug(e,drugData,'','cims')
   
  };

  render() {
    const { isPracticing, dataLoaded } = this.state;
    var basic_vitals = [];
    if (this.state.heightbmi && this.state.heightbmi != null) { basic_vitals.push('Height ' + this.state.heightbmi + ' cm') }
    if (this.state.weightbmi && this.state.weightbmi != null) { basic_vitals.push('Weight ' + this.state.weightbmi + ' kg') }
    if (this.state.bmi && this.state.bmi != null) { basic_vitals.push('BMI ' + this.state.bmi) }
    if (this.state.bsa && this.state.bsa != null) { basic_vitals.push('BSA ' + this.state.bsa) }
    var basic_vitals_string = basic_vitals.join(" | ");
    return (
      <>
        {
          dataLoaded == true
            ?
            <>
              <div className="card-body medicines_body p-1 emrfrm">
                <div className='container-fluid medicines  med-cont pb-2'>
                  <div className='row'>
                    <div className='col-xl-4 col-lg-5 mt-0'>
                      <div className='row'>
                        <div className='col-12'>
                          <span className='text-primary med-font'>{basic_vitals_string}</span>
                        </div>
                      </div>
                    </div>
                    {
                      this.state.diabaticPatient == true
                        ?
                        <>
                          <div className='col-xl-5 col-lg-3'>
                            <div className='row mt-0'>
                              <div className='col-6 text-right'>
                                <span className='text-primary med-font'>Target Blood Sugar(mg/dL)</span>
                                <div>
                                  <label style={{ fontSize: "14px", whiteSpace: "nowrap" }} className="text-secondary">
                                    {this.state.target_blood_sugar_error_message}
                                  </label>
                                </div>
                              </div>
                              <div className='col-3 pr-0'>
                                <div className="form-group hasdata mb-0">
                                  <input
                                    type="text"
                                    className="form-control drug-input mandatory-field onlynumbers border-right-plan"
                                    maxLength="4"
                                    name="target_blood_sugar_min"
                                    id="target_blood_sugar_min"
                                    onChange={(e) => { this.onChangeTargetBloodSugar(e) }}
                                    value={this.state?.target_blood_sugar_min ? this.state.target_blood_sugar_min : ""}
                                    defaultValue={this.state?.target_blood_sugar_min ? this.state.target_blood_sugar_min : ""}
                                  />
                                  <label htmlFor="target_blood_sugar_min">From</label>
                                </div>
                              </div>
                              <div className='col-3 pl-0'>
                                <div className="form-group hasdata mb-0">
                                  <input
                                    type="text"
                                    className="form-control drug-input mandatory-field onlynumbers border-left-plan"
                                    maxLength="4"
                                    name="target_blood_sugar_max"
                                    id="target_blood_sugar_max"
                                    onChange={(e) => { this.onChangeTargetBloodSugar(e) }}
                                    value={this.state?.target_blood_sugar_max ? this.state.target_blood_sugar_max : ""}
                                    defaultValue={this.state?.target_blood_sugar_max ? this.state.target_blood_sugar_max : ""}
                                  />
                                  <label htmlFor="To">To</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                        :
                        null
                    }
                    {/* <div className='col-xl col-lg mt-0'>
                    <div className='row'>
                      <div className='col-12 text-right'>
                        <a 
                          class="btn btn-outline-secondary mr-2 px-2"
                          id="care_protocol"
                          href="#"
                          onClick={(e) => {
                            this.state.allowEdit && this.handleOrderSetPopup(e, 'show');
                          }}
                        >
                          ORDER SET
                        </a>
                        <a 
                          class="btn btn-outline-primary ml-2 px-2"
                          id="diagnosis"
                          href="#"
                          onClick={(e) => {
                            this.state.allowEdit && this.handleModalPopup(e, !isPracticing ? "isPracticingModal" : "showMedicineModal");
                          }}
                        >
                          + MEDICINES
                        </a>
                      </div>
                    </div>
                  </div> */}
                  </div>

                  {
                    this.state.favourite?.medicines?.length > 0
                      ?
                      <div className="card card-blue-card mt-1 mb-2">
                        <div className="card-body">
                          <div className='row '>
                            <div className='col-1'>
                              <div className='row'>
                                <div className='col-12'>
                                  <span className='fav-text'>Favourites</span>
                                </div>
                                {
                                  this.state.favourite?.medicines?.length > 20
                                    ?
                                    <div className='col-12'>
                                      <a className='text-secondary' onClick={() => { this.setState({ planFavDrugsModal: true }) }}><u>View All</u></a>
                                    </div>
                                    :
                                    null
                                }
                              </div>
                            </div>
                            <div className='col-11'>
                              <div className='row'>
                                <div className='col-12'>
                                  <ul className='list-unstyled d-flex flex-wrap'>
                                    {this.state.favourite?.medicines?.map((data, i) => {
                                      return (
                                        <>
                                          {
                                            i < 20
                                              ?
                                              <li className='pr-3 pb-2 col-3'>
                                                <div className="custom-control custom-checkbox custom-control-inline mr-1">
                                                  <input type="checkbox" className="custom-control-input" name="fav_list" checked={data.is_selected == 'Y' ? true : false} id={'fav_' + data.id} disabled={data.is_selected == 'Y' ? true : false} onChange={e => this.selectFavDrug(e, data, i)} />
                                                  <label className="custom-control-label" htmlFor={'fav_' + data.id}>
                                                    <Tooltip overlayInnerStyle={{ color: "#fff", backgroundColor: '#666', borderRadius: '6px' }} placement="top" title={data.name}>
                                                      <div style={{ overflow: 'hidden', maxWidth: '20ch', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.95rem' }}>{data.name}</div>
                                                    </Tooltip>
                                                  </label>
                                                  <span className="pl-2">
                                                    <i className="icon_unique icon_star favourite align-star cursor-pointer" onClick={() => this.markDrugFavorite(data)}></i>
                                                  </span>
                                                </div>
                                              </li>
                                              :
                                              null
                                          }
                                        </>
                                      )
                                    })}
                                  </ul>

                                </div>
                              </div>

                            </div>
                          </div>

                        </div>
                      </div>
                      :
                      null
                  }

                  <MedicineTable
                    drugsData={this.state.drugsData}
                    viewType={"soap-view"}
                    showAction={true}
                    showSelectCheck={false}
                    constants={this.state.constants}
                    handlePopUp={this.handleModalPopup}
                    handleDeleteAll={this.handleDeleteAll}
                    isPracticing={isPracticing}
                    practiceModal={this.handlePracticeModal}
                    deleteAllMedicineOnce={true}
                    editGrid={true}
                    updateMedicineData={this.handleInitialData}
                  />
                </div>
              </div>
              <Modal
                title="Medicine Prescribed Alert"
                visible={this.state.duplicateMedModel}
                onCancel={(e) => this.handleMedPrecribedCancel()}
                footer={false}
                closable={false}
              >
                <div className="row mb-3">
                  {
                    this.state.showDupMed && this.state.showDupMed.length > 0 ?
                      <div className="col-12 text-primary"><span className="font-weight-bold">
                        {this.state.showDupMed.map((drug, i) => {
                          if (this.state.showDupMed.length == i + 1) {
                            return drug.drug_name + "  "
                          } else {
                            return drug.drug_name + "  , "
                          }
                        }
                        )}
                      </span>  medicines is already prescribed to the patient. Are you sure you want to stop the medication and prescribe again? </div>
                      : null
                  }

                </div>
                <div className="modal-footer justify-content-center emrfrm pb-0">
                  <button type="button" className="btn btn-outline-secondary px-5  mr-2 text-uppercase" onClick={(e) => this.handleMedPrecribedCancel(e)}>No</button>
                  <button type="button" className="btn btn-primary px-5 text-uppercase" onClick={(e) => this.stopCurentMeds(e)}>YES</button>
                </div>
              </Modal>
              <Modal
                title="Poly Pharmacy Alert"
                visible={this.state.polyPharmacyFavModal}
                onCancel={(e) => this.handlePolyFavCancel()}
                footer={false}
                closable={false}
              >
                <div className="row mb-3">
                  <div className="col-12">The patient is already on {this.state.current_medicines?.length} medications. Are you sure you want to prescribe more?</div>
                </div>
                <div className="modal-footer justify-content-center emrfrm pb-0">
                  <button type="button" className="btn btn-outline-secondary px-5  mr-2 text-uppercase" onClick={(e) => this.handlePolyFavCancel(e)}>No</button>
                  <button type="button" className="btn btn-primary px-5 text-uppercase" onClick={(e) => this.handlePolyFavOk(e)}>Yes</button>
                </div>
              </Modal>

              <Modal
                title="Poly Pharmacy Alert"
                visible={this.state.polyPharmacyModal}
                onCancel={(e) => this.handlePolyCancel()}
                footer={false}
                closable={false}
              >
                <div className="row mb-3">
                  <div className="col-12">The patient is already on {this.state.current_medicines?.length} medications. Are you sure you want to prescribe more?</div>
                </div>
                <div className="modal-footer justify-content-center emrfrm pb-0">
                  <button type="button" className="btn btn-outline-secondary px-5  mr-2 text-uppercase" onClick={(e) => this.handlePolyCancel(e)}>No</button>
                  <button type="button" className="btn btn-primary px-5 text-uppercase" onClick={(e) => this.handlePolyOk(e)}>Yes</button>
                </div>
              </Modal>

              {/* Favorite Drugs Complete List */}
              <Modal
                destroyOnClose={true}
                title='Favourite Drugs'
                visible={this.state.planFavDrugsModal}
                onCancel={() => this.handleCancel()}
                footer={false}
                width="850px"
                className="tests_modal"
              >
                <div className='row fav_modal emrfrm'>
                  <div className='col-12'>
                    <div className="form-group">
                      <label htmlFor="search-template">
                        Search Favourites
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        className="form-control"
                        id="search-template"
                        placeholder="Search Favourites"
                        onChange={this.FavouriteListLoad}
                      />
                    </div>
                    <table className="table table-bordered fav_modal_table mt-3" id="diagnosis-list">
                      <thead>
                        <tr>
                          <td width="10%"></td>
                          <td width="75%">Drug NAME</td>
                          <td width="15%">FAVOURITE</td>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.favourite_list_all?.medicines?.map((data, i) => {
                          return (<tr>
                            <td className='text-center'>
                              <div className="custom-control custom-checkbox custom-control-inline mr-0">
                                <input type="checkbox" className="custom-control-input" name="fav_check" checked={data.is_selected == 'Y' ? true : false} id={'fav_' + data.id} disabled={data.is_selected == 'Y' ? true : false} onChange={e => this.selectFavDrug(e, data, i)} />
                                <label className="custom-control-label" htmlFor={'fav_' + data.id}></label>
                              </div>
                            </td>
                            <td>{data.name}</td>
                            <td className='text-center'>
                              <span className="">
                                <i className="icon_unique icon_star favourite align-star cursor-pointer" onClick={() => this.markDrugFavorite(data)}></i>
                              </span>
                            </td>
                          </tr>)
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Modal>

              {/* Add New Drug  */}
              {this.state.showMedicineModal ? (
                <Modal
                  title={this.state.actionText + " Medicine"}
                  visible={this.state.showMedicineModal}
                  onCancel={(e) => this.handleModalPopup(e, "showMedicineModal")}
                  footer={this.state.medicine_success != '' ?
                    <div className="text-center mt-1">
                      <span style={{ color: '#548f3a' }}>{this.state.medicine_success}</span>
                    </div> : false
                  }
                  width="1200px"
                  className='medicine_pop_padding'
                >
                  {this.state.showMedicineModal ? (
                    <MedicineForm
                      formType={"soap-modal"}
                      actionText={this.state.actionText}
                      updateData={this.updateMedicineData}
                      autofocus={false}
                      /* selectedDrug={this.state.selectedDrug} */
                      editData={this.state.editData}
                      editIndex={this.state.editIndex}
                      addedDrugsList={this.state.addedDrugsList}
                      constants={this.state.constants}
                      patient={this.state.patient}
                      clearEdit={this.clearEdit}
                      polyPharmacyWarningShown={this.state.polyPharmacyWarningShown}
                      updatepolyPharmacyWarningShown={this.polyPharmacyWarningShown}
                      showtapper ={this.state.showtapper}
                    />
                  ) : null}
                </Modal>
              ) : null}

              {/* Delete added test */}
              <Modal
                title={false}
                visible={this.state.deleteConfirmModal}
                onCancel={(e) => this.handleModalPopup(e, "deleteConfirmModal")}
                footer={false}
                closable={false}
              >
                <div className="row mb-3">
                  <h6 className="col-12 text-center">{this.state.deleteMessage}</h6>
                </div>
                <div className="modal-footer justify-content-center emrfrm pb-0">
                  <button type="button" className="btn btn-outline-secondary px-5  mr-2" onClick={(e) => this.handleModalPopup(e, "deleteConfirmModal")}>
                    CANCEL
                  </button>
                  <button
                    ref={this.deleteButton}
                    type="button"
                    className="btn btn-primary px-5"
                    onClick={(e) => this.handleOnItemDelete(e, this.state.deleteActionType, this.state.deleteObjId)}
                  >
                    DELETE
                  </button>
                </div>
              </Modal>

              <Modal className="myDrugsInteraction_modal" id="myDrugsInteraction"
                title="Drug Interaction"
                visible={this.state.isModalInteractionVisible}
                onOk={() => this.handleInteractionOk()}
                onCancel={() => this.handleInteractionCancel()}
                footer={false}
                style={{width:1000}}
                zIndex={9999}
                >
                
                <iframe id="drug_interaction_widget_iframe2" title="interaction" className="cimsiframe" src={`${CIMS_INTERACTION}?drugIds=${this.state.drug_id_Interaction_Modalurl}&referenceId=${this.state.referenceId}&referenceType=${this.state.referenceType}&enterpriseId=${this.state.enterpriseId}&FacilityId=${this.state.FacilityId}&StoreId=${this.state.StoreId}&patientId=${this.state.patientId}&orederSetId=${this.state.orederSetId}&careProtoColId=${0}&medicineScreen=${'medicineform'}&addedAssessmentList=${0}`}></iframe>
                <div className="modal-footer justify-content-center emrfrm pb-0">
                  <button type="button" className="btn btn-outline-secondary px-5  mr-2 text-uppercase" onClick={(e) => this.handleInteractionCancel(e)}>DON’T PROCEED</button>
                  <button type="button" className="btn btn-primary px-5 text-uppercase" onClick={(e) => this.handleInteractionOk(e)}>PROCEED TO ORDER</button>
                </div>
              </Modal>


              <Modal className="myDrugsInteraction_modal" id="myDrugsInteraction"
                title="Drug Interaction"
                visible={this.state.isModalInteractionVisibleFav}
                onOk={() => this.handleInteractionOkFav()}
                onCancel={() => this.handleInteractionCancelFav()}
                footer={false}
                style={{width:1000}}
                zIndex={9999}
                >
                <iframe id="drug_interaction_widget_iframe2" title="interaction" className="cimsiframe" src={`${CIMS_INTERACTION}?drugIds=${this.state.drug_id_Interaction_Modalurl}&referenceId=${this.state.referenceId}&referenceType=${this.state.referenceType}&enterpriseId=${this.state.enterpriseId}&FacilityId=${this.state.FacilityId}&StoreId=${this.state.StoreId}&patientId=${this.state.patientId}&orederSetId=${this.state.orederSetId}&careProtoColId=${0}&medicineScreen=${'addFavMed'}&addedAssessmentList=${0}`}></iframe>
                <div className="modal-footer justify-content-center emrfrm pb-0">
                  <button type="button" className="btn btn-outline-secondary px-5  mr-2 text-uppercase" onClick={(e) => this.handleInteractionCancelFav(e)}>DON’T PROCEED</button>
                  <button type="button" className="btn btn-primary px-5 text-uppercase" onClick={(e) => this.handleInteractionOkFav(e)}>PROCEED TO ORDER</button>
                </div>
              </Modal>

              {/* Apply orderset  */}
              {this.state.showOrdersetModal ? (
                <Modal
                  title="Apply Order Set"
                  visible={this.state.showOrdersetModal}
                  onCancel={(e) => this.handleOrderSetPopup(e, 'hide')}
                  footer={
                    <div className="col-12 text-center">
                      <Button key="back" className="btn btn-outline-secondary px-5 cancelOrderSet" onClick={(e) => this.handleOrderSetPopup(e, 'hide')}>
                        CANCEL
                      </Button>
                      <Button key="submit" className="btn btn-primary px-5 deleteOrderSet" type="primary" disabled={this.state.diableConfrimButton} onClick={(e) => this.IsApplyOrdersets(e)}>
                        CONFIRM
                      </Button>
                    </div>
                  }
                  width="992px"
                // bodyStyle={{ padding: "10px 20px" }}
                >


                  {this.state.showOrdersetModal ? (
                    <OrdersetList
                      formType={"copy-to-visit"}
                      selectOrderSet={this.selectOrderSet}
                      patient={this.state.patient}
                      selectedOrderSet={this.state.selectedOrderSet}
                    />
                  ) : null}
                </Modal>
              ) : null}
              <MedicineForm
                formType={"hidden"}
                actionText={this.state.actionText}
                updateData={this.updateMedicineData}
                autofocus={false}
                /* selectedDrug={this.state.selectedDrug} */
                editData={this.state.editData}
                editIndex={this.state.editIndex}
                addedDrugsList={this.state.addedDrugsList}
                constants={this.state.constants}
                patient={this.state.patient}
                clearEdit={this.clearEdit}
                polyPharmacyWarningShown={this.state.polyPharmacyWarningShown}
                updatepolyPharmacyWarningShown={this.polyPharmacyWarningShown}
                ref={this.medFormRef}
              />
            </>
            :
            LOADER
        }
      </>
    );
  }
}

export default PlanMedicineComponentSS;